import { storeCategoryProps, storeProductProps } from '../data/shopdata.type';

import { RefObject } from 'react';
import { StoreProductCard } from '@/components/ordering/StoreProductCard/StoreProductCard';

interface categoryProps {
	category: storeCategoryProps;
	reference?: RefObject<(HTMLDivElement | null)[]>;
	categoryIndex?: number | undefined;
	isSingleColumnPlpFlagEnabled: boolean;
}

export function MenuNavigationPanelContents({
	category,
	reference,
	categoryIndex,
	isSingleColumnPlpFlagEnabled,
}: categoryProps) {
	return (
		<div
			className="category-section my-8"
			ref={(el) => {
				if (reference && reference.current && categoryIndex !== undefined) {
					reference.current[categoryIndex] = el;
				}
			}}
			id={`${categoryIndex}`}
			key={categoryIndex}
		>
			<h1
				className="my-3.5 uppercase md:my-4 xl:my-5"
				data-ink="medium"
				data-type-style="subtitle-1"
			>
				{category.name}
			</h1>
			<div
				className={
					isSingleColumnPlpFlagEnabled
						? 'grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4'
						: 'grid grid-cols-2 gap-3 px-2 md:grid-cols-3 md:gap-6 md:px-0 lg:grid-cols-4 xl:w-[1280px] xl:grid-cols-6 xl:p-0'
				}
			>
				{category.products.map((product: storeProductProps) => {
					return (
						<StoreProductCard
							key={product.id}
							product={product}
							isCustomizable={
								product.optionGroups && product.optionGroups.length > 0 ? true : false
							}
							isUpsell={false}
							isSingleColumnPlpFlagEnabled={isSingleColumnPlpFlagEnabled}
						/>
					);
				})}
			</div>
		</div>
	);
}
